import { render, staticRenderFns } from "./GBPhotoAlbumEdit.vue?vue&type=template&id=8c840602&"
import script from "./GBPhotoAlbumEdit.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumEdit.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VForm,VIcon,VLayout,VProgressCircular,VSelect,VSpacer,VTextField})
